module.exports = __webpack_public_path__ + "static/media/KaTeX_Main-Bold.aaaa1b76.ttf";